// ============================================
// MyPage - State (Zustand 기반)
// ============================================
// 이 파일은 하위 호환성을 위해 유지됩니다.
// 새 코드에서는 stores/mypageStore.js에서 직접 import하세요.
// ============================================

import { useMypageStore } from '../../stores/mypageStore.js';

// ============================================
// Database (로컬 유지)
// ============================================

let mypageDb = null;

// ============================================
// My Page Works (로컬 상태)
// ============================================

let myPageWorks = [];

export function getMyPageWorks() {
  return myPageWorks;
}

export function setMyPageWorks(works) {
  myPageWorks = works;
}

export function getDb() {
  if (!mypageDb) {
    mypageDb = firebase.firestore();
  }
  return mypageDb;
}

// ============================================
// Carbon History State
// ============================================

export function getCarbonHistoryData() {
  return useMypageStore.getState().carbonHistoryData;
}

export function setCarbonHistoryData(data) {
  useMypageStore.getState().setCarbonHistoryData(data);
}

export function getCurrentHistoryFilter() {
  return useMypageStore.getState().currentHistoryFilter;
}

export function setCurrentHistoryFilter(filter) {
  useMypageStore.getState().setCurrentHistoryFilter(filter);
}

// ============================================
// Avatar Cache State
// ============================================

export function getAvatarState() {
  return useMypageStore.getState().getAvatarState();
}

export function setAvatarImageData(data) {
  useMypageStore.getState().setAvatarImageData(data);
}

export function setAvatarObjectPosition(position) {
  useMypageStore.getState().setAvatarObjectPosition(position);
}

export function updateAvatarCache(url, position) {
  useMypageStore.getState().updateAvatarCache(url, position);
}

export function setAvatarLoaded(loaded) {
  useMypageStore.getState().setAvatarLoaded(loaded);
}

export function setCachedAvatarUrl(url) {
  useMypageStore.getState().setCachedAvatarUrl(url);
}

export function setCachedAvatarPosition(position) {
  useMypageStore.getState().setCachedAvatarPosition(position);
}
